import React from "react";
import PropTypes, { arrayOf } from "prop-types";
import { getValueFromType } from "./helpers";
import { TABLE_FIELDS_LABELS, TABLE_FIELDS } from "./constants";
import HelperText from "../../../../components/atoms/HelperText";

const getRows = (item, name, colNum) => {
  const tableFields = TABLE_FIELDS[name];
  const displayFields = [];

  for (const key in item) {
    if (tableFields.includes(key) && item[key] != null) {
      displayFields[key] = item[key];
    }
  }

  const tableColNum = Object.keys(displayFields).length;

  const row = [];
  let column = null;
  for (const k in displayFields) {
    const value = getValueFromType(k, displayFields);

    column = (
      <td key={k}>
        <div className="varsome-horiz-list-item">
          <div className="varsome-horiz-list-label">
            {TABLE_FIELDS_LABELS[k]}
            <HelperText fieldDescriptionKey={TABLE_FIELDS_LABELS[k]} />
          </div>
          <div className="varsome-horiz-list-value">{value}</div>
        </div>
      </td>
    );
    row.push(column);
  }

  const addCols = colNum - tableColNum;

  for (let i = 0; i < addCols; i++) {
    row.push(<td key={i} />);
  }

  return <tr key={name}>{row}</tr>;
};

const Table = ({ item, prefix, title }) => {
  const rows = prefix?.map((p) => {
    return getRows(item, p, 4);
  });

  return (
    <div style={{ marginTop: "1rem" }}>
      <h5>{title}</h5>
      <table className="varsome-table">
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
};

const { string, shape } = PropTypes;

Table.propTypes = {
  item: shape({}),
  prefix: arrayOf(string),
  title: string,
};

Table.defaultProps = {
  item: null,
  prefix: null,
  title: null,
};
export default Table;
